
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-collections",
      function () {
        return require("private-next-pages/car-collections.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car-collections"])
      });
    }
  